/* eslint-disable */
import settings from "../../../configs/settings";
import { Box, Paper, TextField, Typography, Fab, Tooltip } from "@mui/material";
import { useContext } from "react";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import CobranzaContext from "../../../project/contexts/CobranzaContext";
import { isNumeric } from "../../../project/utils/utils";
//
// ################################################################################
//
const CobroOtro = () => {
  const {
    setMessage,
    setShowMessage,
    handleChangeMedioDeCobro,
    limpiaMedioDeCobro,
    medioDeCobroAction,
    medioDeCobro,
    setMedioDeCobro,
    agregaMedioDeCobro,
    setExpandedAccordionMediosDeCobro,
    restoACobrar,
  } = useContext(CobranzaContext);

  const { descripcionOtro, importe } = medioDeCobro;
  const _importeAnterior = medioDeCobro.importe;
  //
  // ################################################################################
  //
  const cancelaCobro = () => {
    limpiaMedioDeCobro();
    setExpandedAccordionMediosDeCobro(false);
  };
  //
  // ################################################################################
  //
  const actualizaCobro = () => {
    // valido los datos del cobro

    if (descripcionOtro === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar la descripción",
      });
      setShowMessage(true);
      return;
    }

    if (typeof importe === "string") {
      if (!isNumeric(importe)) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un importe mayor a 0",
        });
        setShowMessage(true);
        return;
      }
    }

    if (+importe <= 0) {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar un importe mayor a 0",
      });
      setShowMessage(true);
      return;
    }

    if (
      +importe >
      (medioDeCobroAction.cu === "new" ? restoACobrar : restoACobrar + _importeAnterior)
    ) {
      setMessage({
        severity: "error",
        messageText: "El importe cobrado debe ser menor o igual al resto a cobrar",
      });
      setShowMessage(true);
      return;
    }

    // si no hay errores agrego el medio de cobro a la tabla de medios de cobro

    agregaMedioDeCobro("otro");
  };
  //
  // ################################################################################
  //
  const asignaRestoACobrar = () => {
    setMedioDeCobro({
      ...medioDeCobro,
      importe: restoACobrar,
    });
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={2} sx={{ mt: 1, p: 2 }}>
        <Typography component={"span"} variant={"body1"}>
          Otra forma de pago
        </Typography>

        <Box sx={{ mt: 1 }}>
          <TextField
            sx={{ width: "100%" }}
            id="descripcionOtro"
            label="Descripción"
            variant="outlined"
            size="small"
            name="descripcionOtro"
            value={descripcionOtro}
            onChange={handleChangeMedioDeCobro}
            inputProps={{
              autoComplete: "off",
            }}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <TextField
            sx={{ width: "50%" }}
            id="importe"
            label="Importe"
            variant="outlined"
            size="small"
            name="importe"
            value={importe.toLocaleString(
              settings.numericLocales.language,
              settings.numericLocales.options
            )}
            onChange={handleChangeMedioDeCobro}
            inputProps={{
              autoComplete: "off",
              style: { textAlign: "right" },
            }}
          />
          <Tooltip title="asignar el resto a cobrar">
            <Fab
              sx={{ ml: 1, mr: 1 }}
              color="secondary"
              aria-label="add"
              size="small"
              onClick={asignaRestoACobrar}
            >
              <PriceChangeOutlinedIcon />
            </Fab>
          </Tooltip>
        </Box>

        <Box sx={{ p: 1 }}>
          <Tooltip title="agregar cobranza">
            <Fab
              sx={{ mr: 1 }}
              color="primary"
              aria-label="add"
              size="small"
              onClick={actualizaCobro}
            >
              <CheckOutlinedIcon />
            </Fab>
          </Tooltip>

          <Tooltip title="cancelar">
            <Fab
              sx={{ mr: 1 }}
              color="outlined"
              aria-label="add"
              size="small"
              onClick={cancelaCobro}
            >
              <CloseOutlinedIcon />
            </Fab>
          </Tooltip>
        </Box>
      </Paper>
    </>
  );
};

export default CobroOtro;
